interface SortableTag {
  id: string;
  hidden?: boolean;
  metadata?: { documentOrder?: number | null };
}

/**
 * Sort a whole-document tag list into reading order using the backend's
 * `metadata.documentOrder` — a single global index computed by walking every
 * section's content in document order, so it already encodes section sequence
 * and page order. Visible tags come before hidden ones; tags with no position
 * (no documentOrder) bucket at the end. The sort is stable, so ties keep their
 * incoming relative order.
 */
export function sortTagsByDocumentOrder<T extends SortableTag>(tags: T[]): T[] {
  const rank = (tag: T): [number, number] => {
    const hiddenRank = tag.hidden ? 1 : 0;
    const documentOrder = tag.metadata?.documentOrder ?? Number.POSITIVE_INFINITY;
    return [hiddenRank, documentOrder];
  };

  return tags
    .map((tag, i) => ({ tag, i, key: rank(tag) }))
    .sort((a, b) => {
      for (let k = 0; k < a.key.length; k++) {
        if (a.key[k] !== b.key[k]) return a.key[k] - b.key[k];
      }
      return a.i - b.i; // stable tiebreak
    })
    .map((entry) => entry.tag);
}
